import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      aria-label="Back to top"
      data-testid="back-to-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 left-6 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full bg-card text-foreground shadow-md border border-border transition-transform duration-300 hover:scale-110 hover:text-primary"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
